import {Pipe, PipeTransform} from '@angular/core';
import {secondsToDurationDisplay} from '../utils/duration.util';

type DurationType = 'hrs' | 'hrs/min' | 'min' | 'min/sec' | 'sec';

/**
 * Pipe to convert seconds to duration display value for inputs
 * Usage: totalSeconds | durationDisplay:durationType:'primary'
 */
@Pipe({
  name: 'durationDisplay',
  standalone: true,
})
export class DurationDisplayPipe implements PipeTransform {
  transform(
    totalSeconds: number | string | null | undefined,
    durationType: DurationType,
    position: 'primary' | 'secondary'
  ): string {
    if (totalSeconds == null || totalSeconds === '') {
      return '';
    }

    const seconds = typeof totalSeconds === 'string' ? parseInt(totalSeconds, 10) : totalSeconds;
    if (isNaN(seconds)) {
      return '';
    }

    const display = secondsToDurationDisplay(seconds, durationType);
    const value = position === 'primary' ? display.primary : display.secondary;

    // For dual input types, pad secondary values
    if (position === 'secondary' && (durationType === 'hrs/min' || durationType === 'min/sec')) {
      return value > 0 || display.primary > 0 ? String(value).padStart(2, '0') : '';
    }

    return value > 0 ? String(value) : '';
  }
}
